import useGraphQLClient from './graphqlClient';
import {
  Forms,
  Genres,
  SortOrder,
  Users,
} from './spotwrite';
import { Metadata } from './types/metadata';

class MetadataService {
  /**
   * ログイン中のユーザの情報を取得して返します。
   * ログインしていない場合は null
   */
  public me = async () => {
    const client = useGraphQLClient();
    try {
      const res = await client.getMe();
      return res.getMe as Users;
    } catch (error) {
      // console.log(error);
      console.log('error on getMe()');
    }
    return undefined;
  }

  /**
   * 登録されているformをidの昇順で取得して返します。
   * @returns
   */
  public forms = async () => {
    const client = useGraphQLClient();
    try {
      const res = await client.findManyForms({
        orderBy: { id: SortOrder.Asc },
      });
      return res.findManyForms as Forms[];
    } catch (error) {
      console.log(error);
    }
    return [];
  }

  /**
   * 登録されているjenreをidの昇順で取得します
   * @returns
   */
  public genres = async () => {
    const client = useGraphQLClient();
    try {
      const res = await client.findManyGenres({
        orderBy: { id: SortOrder.Asc },
      });
      return res.findManyGenres as Genres[];
    } catch (error) {
      console.log(error);
    }
    return [];
  }

  /**
   * メタデータとして、ジャンル一覧・工程一覧・ログインユーザ情報を取得して帰します。
   * @returns
   */
  public get = async () => {
    const forms = await this.forms();
    const genres = await this.genres();
    const me = await this.me();

    return {
      forms,
      genres,
      me,
    } as Metadata;
  }
}
export default new MetadataService();
